var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse, _path12, _rect4, _ellipse2, _path13, _rect5, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavannahThumbnailGray = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#505862",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 72V91C101 96.5228 96.5228 101 91 101H28.5C28.5 97.8 37.3 84 38.45 82.5C44.315 79 54.63 81.5 68.085 82.5C78.849 83.3 93.41 75.8333 101 72Z",
    fill: "#B9BEC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0148 58.223C96.8577 57.1297 95.844 56.3708 94.7506 56.5279L93.4007 56.7219C92.3074 56.8791 91.5485 57.8928 91.7056 58.9861L91.7725 59.4511C91.9296 60.5445 91.1707 61.5582 90.0773 61.7153L11.744 72.974C10.6506 73.1312 9.89171 74.1449 10.0489 75.2382L10.37 77.473C10.5272 78.5663 11.5409 79.3252 12.6342 79.1681L96.2768 67.1463C97.3701 66.9892 98.1291 65.9755 97.9719 64.8821L97.0148 58.223Z",
    fill: "#D5D8DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7939 56.6858C96.7588 56.4415 96.5322 56.2718 96.2878 56.307C96.0435 56.3421 95.8739 56.5686 95.909 56.813L96.8327 63.2396C96.9898 64.3329 96.2309 65.3466 95.1376 65.5038L11.2851 77.5557C10.7964 77.626 10.4572 78.0791 10.5274 78.5678C10.5976 79.0565 11.0507 79.3957 11.5394 79.3255L96.2768 67.1463C97.3701 66.9892 98.1291 65.9755 97.9719 64.8821L96.7939 56.6858Z",
    fill: "#F1F2F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5698 24.8022L54.2244 24.4207L64.8644 48.1795L62.2098 48.5611L51.5698 24.8022Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3267 33.418L54.1029 29.8569L60.9437 46.0335L31.7431 50.2305L29.3267 33.418Z",
    fill: "#D5D8DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3267 33.418L36.4056 32.4005L43.2464 48.5771L31.7431 50.2305L29.3267 33.418Z",
    fill: "#9DA4AF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.99219,
    y: 43.4221,
    width: 16.9852,
    height: 10.7275,
    rx: 2,
    transform: "rotate(-8.179 9.99219 43.4221)",
    fill: "#9DA4AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2767 45.4018C10.1196 44.3084 10.8785 43.2947 11.9718 43.1376L15.3014 42.659L16.8276 53.2774L13.498 53.756C12.4047 53.9131 11.391 53.1542 11.2338 52.0609L10.2767 45.4018Z",
    fill: "#818A98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.558 29.4207C30.2838 27.5131 27.7354 27.0588 26.8189 28.7542L15.1775 50.2899C14.3961 51.7355 15.5948 53.4544 17.2215 53.2206L19.8647 52.8407C19.3526 52.2641 19.1703 51.4014 19.5721 50.6066L24.8218 40.2197C25.7039 38.4745 28.3083 38.9018 28.5865 40.8373L29.9428 50.2748C30.001 50.6796 29.9336 51.0735 29.7701 51.417L31.6598 51.1455C32.7531 50.9883 33.512 49.9746 33.3549 48.8813L30.558 29.4207Z",
    fill: "#F1F2F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9853 51.2424L31.8702 51.1152C32.8475 50.9747 33.5261 50.0685 33.3856 49.0911L30.4671 28.7854C30.2595 27.3412 28.5939 26.8287 27.591 27.6263L30.9853 51.2424Z",
    fill: "#B9BEC6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3329 58.3591C9.94006 55.6257 11.8374 53.0914 14.5707 52.6986L86.9651 42.2935C89.6985 41.9006 92.2327 43.7979 92.6256 46.5313L94.8394 61.9341L12.5467 73.7619L10.3329 58.3591Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3329 58.3591C9.94006 55.6257 11.8374 53.0914 14.5707 52.6986L26.7286 50.9511C28.699 50.6679 30.6497 51.5805 31.6951 53.2746L41.7474 69.5649L12.5467 73.7619L10.3329 58.3591Z",
    fill: "#D5D8DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3134,
    cy: 75.6494,
    r: 14.3034,
    transform: "rotate(-8.179 27.3134 75.6494)",
    fill: "#9DA4AF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.6356,
    cy: 68.2729,
    r: 14.3034,
    transform: "rotate(-8.179 78.6356 68.2729)",
    fill: "#9DA4AF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2131,
    cy: 75.2666,
    r: 7.15168,
    transform: "rotate(-8.179 27.2131 75.2666)",
    fill: "#F1F2F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5353,
    cy: 67.8901,
    r: 7.15168,
    transform: "rotate(-8.179 78.5353 67.8901)",
    fill: "#F1F2F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2129,
    cy: 75.2663,
    r: 5.36376,
    transform: "rotate(-8.179 27.2129 75.2663)",
    fill: "#9DA4AF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.5357,
    cy: 67.8899,
    r: 5.36376,
    transform: "rotate(-8.179 78.5357 67.8899)",
    fill: "#9DA4AF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4889,
    cy: 48.7247,
    rx: 2.2349,
    ry: 5.36376,
    transform: "rotate(-8.179 92.4889 48.7247)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0465 48.7882C92.4679 51.7204 94.4738 53.8583 93.252 54.0339C92.0303 54.2095 90.6982 51.9748 90.2768 49.0426C89.8553 46.1104 90.5041 43.591 91.7258 43.4154C92.9476 43.2398 91.6251 45.856 92.0465 48.7882Z",
    fill: "#B9BEC6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.45117,
    y: 55.8157,
    width: 4.4698,
    height: 16.9852,
    rx: 2,
    transform: "rotate(-8.179 5.45117 55.8157)",
    fill: "#9DA4AF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5609,
    cy: 24.9481,
    rx: 3.12886,
    ry: 4.02282,
    transform: "rotate(-8.179 28.5609 24.9481)",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6761 25.0753C27.9922 27.2745 30.8437 28.6842 29.1333 28.9301C27.4228 29.1759 25.78 27.5924 25.4639 25.3933C25.1478 23.1941 26.2782 21.2121 27.9886 20.9662C29.6991 20.7204 27.36 22.8762 27.6761 25.0753Z",
    fill: "#B9BEC6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.0884,
    y: 51.7405,
    width: 8.04564,
    height: 2.68188,
    rx: 1.34094,
    transform: "rotate(-8.179 40.0884 51.7405)",
    fill: "#9DA4AF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 82V91C1 96.5228 5.47715 101 11 101H92C92 97.8 88.6333 94 86.95 92.5C78.365 89 74.73 91.5 55.035 92.5C39.279 93.3 12.11 85.8333 1 82Z",
    fill: "#9DA4AF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavannahThumbnailGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SavannahThumbnail-gray.0d95d0ab895602fbe659e1a14a19ec5d.svg";